<div class="dialog-container">
  @if (showDiscardConfirmation()) {
    <div class="discard-confirmation-view">
      <img src="assets/img/icons/challenge-builder/traffic-cone.png" alt="Warning" class="warning-icon" />
      <h2 class="discard-title">You have un-saved changes</h2>
      <oph-button
        color="green"
        [loading]="loading()"
        [disabled]="loading()"
        (buttonClick)="onConfirmSave()"
        [style]="{'border-radius': '10px', width: '178px', height: '40px'}"
        class="discard-save-btn"
      >
        Save my changes
      </oph-button>
      <oph-button
        color="gray"
        appearance="outline"
        [style]="{'border-radius': '10px', width: '178px', height: '40px'}"
        (buttonClick)="onConfirmAbandon()"
        class="discard-abandon-btn"
      >
        Abandon
      </oph-button>
    </div>
  } @else {
    <!-- Xsmall only: top bar with Back + Save Entry -->
    <div class="dialog-actions-xsmall">
      <button type="button" class="xsmall-back" (click)="onCancel()" aria-label="Back">
        <mat-icon svgIcon="chevron-left"></mat-icon>
        <span>Back</span>
      </button>
      <oph-button
        [color]="isViewMode() ? undefined : 'green'"
        [colorHex]="isViewMode() ? '#ED9111' : undefined"
        [colorHexText]="isViewMode() ? '#fff' : undefined"
        [loading]="loading()"
        [disabled]="primaryActionDisabled()"
        (buttonClick)="onPrimaryAction()"
        [style]="{'border-radius': '10px', width: '156px', height: '40px'}"
        >{{ saveButtonLabel() }}</oph-button
      >
    </div>

    <div class="dialog-header">
      <img [src]="'assets/img/icons/color-icons/' + task.icon + '.svg'" [alt]="task.label" class="dialog-header-icon" />
      <h2 class="dialog-header-title">{{ task.label }}</h2>
      <oph-x-button class="dialog-close" (click)="onCancel()" title="Close dialog" />
    </div>

    <div class="dialog-content oph-scroll-bar">
      @if (task.metrics?.length) {
        <div class="metrics-wrapper" [class.view-mode]="isViewMode()">
          @for (metric of task.metrics; track metric._id) {
            <div class="metric-block">
              <div class="metric-label">{{ metric.name }}</div>

              @if (metric.type === MetricTypes.Numeric && metric.uom) {
                <div class="numeric-input-wrap">
                  <input
                    class="metric-input numeric-input"
                    type="number"
                    [value]="metric._id ? stringValues()[metric._id] ?? '' : ''"
                    (input)="setStringValue(metric._id, $any($event.target).value)"
                    [disabled]="isViewMode()"
                  />
                  <span class="numeric-uom">{{ metric.uom }}</span>
                </div>
              }

              @if (metric.type === MetricTypes.Boolean) {
                <div class="boolean-toggle">
                  <button
                    type="button"
                    class="bool-btn"
                    [class.selected]="(metric._id ? booleanValues()[metric._id] : null) === 1"
                    (click)="toggleBoolean(metric._id, 1)"
                    [disabled]="isViewMode()"
                  >
                    Yes
                  </button>
                  <div class="bool-divider"></div>
                  <button
                    type="button"
                    class="bool-btn"
                    [class.selected]="(metric._id ? booleanValues()[metric._id] : null) === 0"
                    (click)="toggleBoolean(metric._id, 0)"
                    [disabled]="isViewMode()"
                  >
                    No
                  </button>
                </div>
              }

              @if (metric.type === MetricTypes.Duration) {
                @if (metric._id && isSingleInputDurationByMetricId()[metric._id]) {
                  <input
                    class="metric-input duration-input duration-single"
                    type="text"
                    inputmode="numeric"
                    [placeholder]="metric._id ? metricTypeOptionById()[metric._id] : ''"
                    [value]="metric._id ? durationValues()[metric._id]?.primary ?? '' : ''"
                    (input)="setDurationPrimary(metric._id, $any($event.target).value)"
                    [disabled]="isViewMode()"
                  />
                } @else {
                  <div class="duration-double">
                    <input
                      class="metric-input duration-input"
                      type="text"
                      inputmode="numeric"
                      [placeholder]="metric._id ? durationPlaceholdersById()[metric._id]?.primary : ''"
                      [value]="metric._id ? durationValues()[metric._id]?.primary ?? '' : ''"
                      (input)="setDurationPrimary(metric._id, $any($event.target).value)"
                      [disabled]="isViewMode()"
                    />
                    <span class="duration-separator">:</span>
                    <input
                      class="metric-input duration-input"
                      type="text"
                      inputmode="numeric"
                      [placeholder]="metric._id ? durationPlaceholdersById()[metric._id]?.secondary : ''"
                      [value]="metric._id ? durationSecondaryDisplayById()[metric._id] ?? '' : ''"
                      (input)="setDurationSecondary(metric._id, $any($event.target).value)"
                      [disabled]="isViewMode()"
                    />
                  </div>
                }
              }

              @if (metric.type === MetricTypes.Numeric && !metric.uom) {
                <div class="percentage-row">
                  <div class="percentage-slider-wrap oph-slider-container">
                    <mat-slider [min]="0" [max]="100" [step]="1" class="percentage-slider" [disabled]="isViewMode()">
                      <input
                        matSliderThumb
                        [value]="metric._id ? percentageValues()[metric._id] ?? 0 : 0"
                        (input)="setPercentageValue(metric._id, $any($event.target).value)"
                      />
                    </mat-slider>
                  </div>
                  <span class="percentage-value">{{ metric._id ? percentageValues()[metric._id] ?? 0 : 0 }}%</span>
                </div>
              }
            </div>
          }
        </div>
      }

      <!-- Desktop/tablet: footer with Cancel + Save -->
      <div class="dialog-actions-desktop">
        <cb-dialog-footer
          [loading]="loading()"
          [saveDisabled]="primaryActionDisabled()"
          [saveLabel]="saveButtonLabel()"
          [saveColorHex]="isViewMode() ? '#ED9111' : undefined"
          [saveColorHexText]="isViewMode() ? '#fff' : undefined"
          (cancel)="onCancel()"
          (save)="onPrimaryAction()"
        />
      </div>
    </div>
  }
</div>
